module.exports = __webpack_public_path__ + "static/img/4c.420ffe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4c.jpg
// module id = 2xM3
// module chunks = 1